export default __webpack_public_path__ + "/ding.mp3";